import styled from 'styled-components';

export const BarStyled = styled.div`
  display: flex;
  gap: 2rem;
`;
